import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

export const AccordionItem = styled("div")(({ active }) => ({
  position: "relative",
  "&:not(:last-of-type)": { paddingBottom: "40px" },
  "&:last-of-type": { ".vertical-line": { height: "0" } },
  "&::before": {
    content: '" "',
    position: "absolute",
    width: "10px",
    height: "10px",
    backgroundColor: active === "active" ? "#FFF" : "#17479e",
    left: "-40px",
    top: "30px",
    borderWidth: 7,
    borderStyle: "solid",
    borderColor: active === "active" ? "#17479E" : "#d3daeb",
    boxSizing: "content-box",
    borderRadius: "50%",
  },
  ".vertical-line": {
    position: "absolute",
    width: "2px",
    left: "-29px",
    top: "43px",
    borderStyle: "dashed",
    borderRightWidth: "2px",
    height: "100%",
  },
}));

export const Accordion = styled(props => (
  <MuiAccordion disableGutters elevation={0} {...props}>
    {props.children}
  </MuiAccordion>
))(() => ({
  borderBottomLeftRadius: "20px !important",
  borderBottomRightRadius: "20px !important",
  borderTopRightRadius: "20px !important",
  borderTopLeftRadius: "20px !important",
  "&:before": {
    display: "none",
  },
}));

export const AccordionSummary = styled(props => (
  <MuiAccordionSummary
    expandIcon={
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 10L12 15L7 10"
          stroke="#737373"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    }
    {...props}
  />
))(() => ({
  backgroundColor: "#FFF",
  borderRadius: 20,
  padding: 25,
  flexDirection: "row-reverse",
  alignItems: "flex-start",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    order: 1,
    flexDirection: "column",
    margin: 0,
    ".date": {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "32px",
      color: "#ED1E24",
      marginBottom: 11,
    },
    ".title": {
      fontWeight: 700,
      fontSize: 18,
      lineHeight: "32px",
      color: "#17479E",
    },
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ hasimage }) => ({
  padding: "0 25px 25px ",
  borderRadius: 20,
  ".contentWrapper": {
    display: "flex",
    justifyContent: "space-between",
    ".contentTextWrapper": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    ".content": {
      flex: 1,
      fontWeight: 400,
      fontSize: "15px",
      lineHeight: "32px",
      color: "#808285",
      marginBottom: 20,
      maxWidth: hasimage === "yes" ? "650px" : "100%",
    },
  },
}));
